import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      
      if (!sessionId) {
        toast.error('Session invalide');
        navigate('/login');
        return;
      }
      
      try {
        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        if (response.data.status === 'success') {
          toast.success('Connexion Google réussie !');
          localStorage.setItem('token', response.data.token);
          
          // Navigate to dashboard with user data
          navigate('/dashboard', { 
            state: { user: response.data.user },
            replace: true 
          });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Erreur d\'authentification Google');
        navigate('/login');
      }
    };
    
    processAuth();
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-void flex items-center justify-center">
      <div className="text-center">
        <div className="font-orbitron text-2xl text-cyan-400 glitch-subtle mb-4">
          L'EFFACEUR
        </div>
        <div className="text-gray-400 font-mono text-sm">
          AUTHENTIFICATION_EN_COURS...
        </div>
        <div className="mt-4">
          <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    </div>
  );
}
